import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import MessageCard from "../AdminCards/MessageCard";
import { languageHelper } from "../../config/helperFunctions";

function CartDetails({
  handleOrder,
  setCouponCode,
  handleApplyCoupon,
  couponDiscount,
  couponError,
  validation,
  currency,
  generalSetting,
  selectedOrderType,
  advancePercentage,
  setAdvancePercentage
}) {
  const outlet = JSON.parse(localStorage.getItem("rms-outlet"));
  const location = useLocation();

  const isCheckout = location.pathname === "/checkout";

  const data = useSelector((state) => state.products.cart);

  let subTotal = 0;
  let totalDiscount = 0;
  let totalExtraToppings = 0;
  let total = 0;
  const isDelivery = selectedOrderType ? selectedOrderType === 2 : (outlet?.orderType === 2);
  const deliveryPrice = 0; // Exclude delivery charges from checkout total calculation

  data.forEach((item) => {
    subTotal += item.price * item.quantity;
    totalDiscount += parseFloat(item.discount) * item.quantity || 0;
    item.modifiers?.forEach((mod) => {
      totalExtraToppings += mod.modifier_price * mod.quantity;
    });
  });

  total += subTotal - totalDiscount + totalExtraToppings + deliveryPrice;

  const finalTotal = couponDiscount !== undefined && couponDiscount !== null ? couponDiscount : total;
  const advanceAmount = isCheckout ? (finalTotal * (advancePercentage || 100)) / 100 : finalTotal;

  return (
    <>
      <div className="flex flex-col w-full  rounded-xl p-5 mt-5 lg:m-5 border border-w-border">
        <p className="text-3xl font-bold text-w-heading">{languageHelper("payment summary") || "Payment Summary"}</p>
        <hr className="my-2 bg-transparent border-t border-w-border border-dashed" />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("sub total") || "Sub Total"}</p>
          </div>
          <div>
            <p>{subTotal.toFixed(2)} {languageHelper(`${currency || "S.R"}`) || `${currency || "S.R"}`}</p>
          </div>
        </div>
        <br />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("discount") || "Discount"}</p>
          </div>
          <div>
            <p>{totalDiscount.toFixed(2)} {languageHelper(`${currency || "S.R"}`) || `${currency || "S.R"}`}</p>
          </div>
        </div>
        <hr className="my-2 bg-transparent border-t border-w-border border-dashed" />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("extra topping") || "Extra Topping"}</p>
          </div>
          <div>
            <p>{totalExtraToppings.toFixed(2)} {languageHelper(`${currency || "S.R"}`) || `${currency || "S.R"}`}</p>
          </div>
        </div>
        <hr className="my-2 bg-transparent border-t border-w-border border-dashed" />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("Delivery") || "Delivery"}</p>
          </div>
          <div>
            {isDelivery ? (
              <p className="text-xs text-amber-700 font-medium italic">
                {languageHelper("To be calculated separately (InDrive/Bykea)") || "To be calculated separately (InDrive/Bykea)"}
              </p>
            ) : (
              <p>{deliveryPrice.toFixed(2)} {languageHelper(`${currency || "S.R"}`) || `${currency || "S.R"}`}</p>
            )}
          </div>
        </div>
        <hr className="my-2 bg-transparent border-t-2 border-w-border border-dashed" />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("total amount")}</p>
          </div>
          <div>
            <p className={`${couponDiscount && "line-through"}`}>{total.toFixed(2)} {languageHelper(`${currency || "S.R"}`) || `${currency || "S.R"}`}</p>
            <p>{couponDiscount && `${couponDiscount.toFixed(2)} ${languageHelper(`${currency || "S.R"}`) || `${currency || "S.R"}`}`}</p>
          </div>
        </div>
        {isCheckout && (
          <>
            <hr className="my-2 bg-transparent border-t border-w-border border-dashed" />
            <div className="flex font-bold justify-between text-purple-900 bg-purple-50 p-2 rounded">
              <div>
                <p>{languageHelper("Advance Payable") || "Advance Payable"} ({advancePercentage}%)</p>
              </div>
              <div>
                <p>{advanceAmount.toFixed(2)} {languageHelper(`${currency || "S.R"}`) || `${currency || "S.R"}`}</p>
              </div>
            </div>
          </>
        )}
        <hr className="my-2 bg-transparent border-t-2 border-w-border border-dashed" />
        {isCheckout && (
          <>
            <div className="mb-4">
              <label className="block font-semibold text-xs mb-2 text-w-heading">
                {languageHelper("Select Advance Payment") || "Select Advance Payment"}
              </label>
              <div className="grid grid-cols-3 gap-2">
                {[30, 50, 100].map((pct) => (
                  <button
                    key={pct}
                    type="button"
                    onClick={() => setAdvancePercentage(pct)}
                    className={`py-2 px-1 text-xs font-bold rounded-lg border text-center transition-all ${advancePercentage === pct
                      ? "bg-[#7B20C7] text-white border-[#7B20C7] shadow-md scale-105"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                      }`}
                  >
                    {pct}% {pct === 100 ? (languageHelper("Full") || "Full") : (languageHelper("Advance") || "Advance")}
                  </button>
                ))}
              </div>
            </div>

            <div className="mb-4 p-3 bg-purple-50 rounded-lg border border-purple-200 text-purple-950 text-xs font-semibold leading-relaxed">
              <p className="font-bold text-purple-900 border-b border-purple-200 pb-1 mb-2 text-sm">
                💳 {languageHelper("Bank Transfer Details") || "Bank Transfer Details"}
              </p>
              <div className="space-y-1">
                <p><span className="text-purple-700 font-medium">{languageHelper("Bank") || "Bank"}:</span> Sadapay</p>
                <p><span className="text-purple-700 font-medium">{languageHelper("Account Title/No") || "Account Title/No"}:</span> 03340397018</p>
                <p><span className="text-purple-700 font-medium">{languageHelper("Account Title") || "Account Title"}:</span> Uzma Shoaib</p>
              </div>
              <p className="mt-2.5 pt-2 border-t border-purple-200 text-purple-900 font-bold text-xs">
                Payable Advance: {advanceAmount.toFixed(2)} {currency || "S.R"}
              </p>
              <p className="mt-2 pt-2 border-t border-purple-200 text-[10px] text-purple-800 font-medium leading-normal">
                📢 {languageHelper("After paying , send the screenshot of the payment and the Order# to the whatsapp number: ") + generalSetting?.whatsapp}
              </p>
            </div>

            <div className="flex gap-2 border border-w-border px-2 py-1 rounded-md">
              <input
                className="w-full px-2 py-1 focus:outline-none"
                placeholder="Coupon Code"
                type="text"
                onChange={(e) => setCouponCode(e.target.value)}
              />
              <button
                onClick={handleApplyCoupon}
                className="bg-w-btn text-w-btn-text px-2 py-1 rounded-md"
              >
                {languageHelper("apply") || "Apply"}
              </button>
            </div>
            {couponError && (
              <div className="mt-2">
                <MessageCard error={couponError} />
              </div>
            )}
            {validation && (
              <div className="mt-2">
                <MessageCard error={validation} />
              </div>
            )}
          </>
        )}
      </div>
      {!isCheckout && (
        <Link
          to="/checkout"
          className="flex justify-center flex-col w-full font-bold text-lg  rounded-lg p-2 mt-5 lg:m-5 border border-w-border bg-w-btn text-w-btn-text"
        >
          <div className="flex justify-center">
            <div>{languageHelper("continue to checkout") || "Continue To Checkout"}</div>
          </div>
        </Link>
      )}
      {isCheckout && (
        <button
          to="/thankyou"
          onClick={handleOrder}
          className="flex justify-center flex-col w-full font-bold text-lg  rounded-lg p-2 mt-5 lg:m-5 border border-w-border bg-w-btn text-w-btn-text"
        >
          <div className="flex justify-center">
            <div>{languageHelper("place order") || "Place Order"}</div>
          </div>
        </button>
      )}
    </>
  );
}

export default CartDetails;
